import { render, staticRenderFns } from "./InventarList.vue?vue&type=template&id=be04f78c&scoped=true&"
import script from "./InventarList.vue?vue&type=script&lang=js&"
export * from "./InventarList.vue?vue&type=script&lang=js&"
import style0 from "./InventarList.vue?vue&type=style&index=0&id=be04f78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be04f78c",
  null
  
)

component.options.__file = "InventarList.vue"
export default component.exports